import { useEffect, useRef, useState } from 'react';

interface ResizeObserverEntry {
  contentRect: {
    width: number;
    height: number;
  };
}

export function useResizeObserver<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    let rafId: number;

    const observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      // Throttle updates with requestAnimationFrame to avoid layout thrash
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        for (const entry of entries) {
          setDimensions({
            width: entry.contentRect.width,
            height: entry.contentRect.height,
          });
        }
      });
    });

    observer.observe(element);

    return () => {
      cancelAnimationFrame(rafId);
      observer.disconnect();
    };
  }, []);

  return { ref, dimensions };
}
